export default "__VITE_ASSET__95510266__"